import GeochoroplethItem from './geochoropleth-map-item';

export default GeochoroplethItem;
export { GeochoroplethItem };
